import loginApi from '../../api'
import {promptData, successPromptData, errorPromptData, getTableHeaderStyle} from '../../util/MessageTools'
import {checkPhoneNumber} from "../../util/checkNumberTools";
import api from "../../api";
import {vuexTimeData, vuexUserData} from "../../util/vuexData";

export default {

  name: 'bindingModal',
  props:['bindState','bindType'],

  data() {
    return {
      name: '登录1',
      registerDiv: false,//注册的div
      loginDiv: true,//登录的div
      updateDiv: false,//修改密码的div
      ordinary: {      //普通登录
        userName: null,
        password: null,
        phone: null,
        verificationCode: null,
      },
      register: {   //注册
        phone: null,
        verificationCode: null,
        userName: null,
        password: null,
        endPassword: null,
      },
      loginRegisterDiv: true,//登录注册Div
      verifyPhoneDiv: true,//验证注册时的手机号码的div
      userDiv: false,//注册时候的用户名密码
      registerSuccess: false,//注册成功
      active: 0,//注册时的步骤步骤
      loginType: "手机认证绑定",
      userLoginDiv: true,//用户名登录的Div
      phoneLoginDiv: false,//手机号验证登录的div
      updatePasswordSuccess: false,//修改密码成功的Div
      registerVerifyBtn: '获取验证码',
      registerDisabled: false,
      ordinaryVerifyBtn: '获取验证码',
      ordinaryDisabled: false,
      //state: null,
      //type:null,//是微信扫码还是qq登录
      // 绑定弹窗的状态
      bindingModalStatus:false,
      // 是否绑定成功
      bindingSuccess: false

    }
  },

  methods: {
    closeDlg(){
      if (!this.bindingSuccess) {
        window.location.reload()
      }
    },
    getError(name) {
      return this.errors[name] && this.errors[name].length
        ? this.errors[name][0]
        : null
    },

    hasError(name) {
      return this.getError(name) != null
    },
    /**
     * 重置普通绑定信息
     */
    resetOrdinary(){
      this.ordinary = {      //普通登录
          userName: null,
          password: null,
          phone: null,
          verificationCode: null,
      }
    },
    /**
     * 重置注册绑定信息
     */
    resetRegister(){
      this.register = {   //注册
          phone: null,
          verificationCode: null,
          userName: null,
          password: null,
          endPassword: null,
      }
    },

    /**
     * 隐藏div
     */
    closeDiv() {
      this.registerDiv = false
      this.loginDiv = false
      this.updateDiv = false
    },

    /**
     * 隐藏div
     */
    closeDiv1() {
      this.verifyPhoneDiv = false
      this.userDiv = false
      this.registerSuccess = false
    },

    /**
     * 登录页
     */
    clickLogin() {
      this.closeDiv()
      this.loginDiv = true
      this.resetRegister()
    },

    /**
     * 注册页
     */
    clickRegister() {
      this.active = 0
      this.closeDiv1()
      this.closeDiv()
      this.verifyPhoneDiv = true
      this.registerDiv = true
      this.resetOrdinary()
    },

    /**
     * 短信验证码登录(切换页面)
     */
    noteVerify() {
      if (this.loginType === "手机认证绑定") {
        this.userLoginDiv = false
        this.phoneLoginDiv = true
        this.loginType = "账号认证绑定"
      } else {
        this.loginType = "手机认证绑定"
        this.userLoginDiv = true
        this.phoneLoginDiv = false
      }
    },

    /**
     * 注册完成去登陆
     */
    registerToLogin() {
      this.active = 0
      this.loginDiv = true;
      this.registerDiv = false
      $('.form_item').removeClass('active')
      $('#loginSpan').addClass('active')
    },

    /**
     *认证 (用户名认证和手机号码认证)
     */
    bindingButton() {
      let useType = ""
      let verifyKey = "";//手机号或者用户名
      let verifyValue = "" //验证码或者密码
      if (this.loginType === '手机认证绑定') {//说明是用户名登录
        useType = 2
        if (this.ordinary.userName === "" || this.ordinary.userName === null) {
          promptData('用户名不能为空,请重新输入!', this)
          return
        }
        if (this.ordinary.password === "" || this.ordinary.password === null) {
          promptData('密码不能为空,请重新输入!', this)
          return
        }
        verifyKey = this.ordinary.userName
        verifyValue = this.ordinary.password

      } else {//短信认证
        useType = 1
        let phoneNumber = this.ordinary.phone
        let verificationCode = this.ordinary.verificationCode
        if (phoneNumber === "" || phoneNumber === null) {
          promptData('手机号不能为空,请重新输入!', this)
          return
        }
        if (verificationCode === "" || verificationCode == null) {
          promptData('验证码不能为空,请重新输入!', this)
          return
        }
        verifyKey = phoneNumber
        verifyValue = verificationCode
      }
      this.bindAccountVxOrQQ(verifyKey, verifyValue, useType)
    },

    /**
     * 注册的第二步
     */
    registerButton() {
      let vue = this
      if (this.register.userName === null || this.register.userName === "") {
        promptData("用户名不能为空!", this)
        return
      }
      if (this.register.password === null || this.register.password === "") {
        promptData("密码不能为空!", this)
        return
      }
      if (this.register.password !== this.register.endPassword) {
        promptData("输入的密码不一样!", this)
        return
      }
      let user = {}
      user.userPhone = this.register.phone
      user.userName = this.register.userName
      user.password = this.register.password
      user.createTime = new Date()
      loginApi.login.register(user).then(function (response) {
        if (response.data.code === '0') {
          vue.active = 2
          vue.userDiv = false
          vue.registerSuccess = true
          vue.bindAccountVxOrQQ(user.userName, user.password, 2)

          // let wait = 5;
          // let timer = setInterval(() => {
          //   if (wait > 0) {
          //     document.getElementById("binding").innerHTML = +wait + "秒后自动绑定";
          //     wait--
          //   } else {
          //     vue.bindAccountVxOrQQ(user.userName, user.password, 2)
          //     clearInterval(timer)
          //   }
          // }, 1000)

        } else {
          errorPromptData(response.data.result, vue)
        }
      })
    },


    bindAccountVxOrQQ(verifyKey, verifyValue, useType) {
      let vue = this
      if (vue.bindType === 'qq') {
        loginApi.login.bindAccountOfQQ(vue.bindState, verifyKey, verifyValue, useType).then(function (response) {
          if (response === null) {
            return
          }
          if (response.data.code === '0') {
            vue.bindingModalStatus = false
            api.login.getGameInfo().then(function (response) {
              if (response == null) {
                return null
              }
              if (response.data.code === "0") {
                let result = response.data.result
                vuexTimeData(result)
              }
            })
            vue.bindingSuccess = true
            vuexUserData(response.data.result)
          }
        })
      } else {
        loginApi.login.bindAccount(vue.bindState, verifyKey, verifyValue, useType).then(function (response) {
          if (response === null) {
            return
          }
          if (response.data.code === '0') {
            vue.bindingModalStatus = false
            api.login.getGameInfo().then(function (response) {
              if (response == null) {
                return null
              }
              if (response.data.code === "0") {
                //把时间存到vuex里
                let result = response.data.result
                vuexTimeData(result)
              }
            })
            vue.bindingSuccess = true
            vuexUserData(response.data.result)
          }
        })
      }
    },

    /**
     * 获取验证码
     * @param type  1为注册  2为短信登录  3为忘记密码
     */
    getVerificationCode(type) {
      let phoneNumber = ""
      switch (type) {
        case 1:
          phoneNumber = this.register.phone
          break
        case 2:
          phoneNumber = this.ordinary.phone
          break
      }

      let vue = this
      if (phoneNumber !== "" && phoneNumber != null) {
        if (checkPhoneNumber(phoneNumber, this)) {

          loginApi.login.verificationCode(phoneNumber, type).then(function (response) {
            if (response == null) {
              return null
            }
            if (response.data.code === "0") {
              vue.tackBtn(type);
            }
          })
        } else {
          return
        }
      } else {
        promptData("请输入手机号!", this)
        return
      }
    },

    /**
     * 验证码倒数60秒  1为注册  2为短信登录  3为忘记密码
     * @param type
     */
    tackBtn(type) {
      let vue = this
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          switch (type) {
            case 1:
              vue.registerVerifyBtn = '获取验证码'
              vue.registerDisabled = false
              break;
            case 2:
              vue.ordinaryVerifyBtn = '获取验证码'
              vue.ordinaryDisabled = false
              break;
          }
        } else {
          switch (type) {
            case 1:
              vue.registerVerifyBtn = time + '秒后重试'
              vue.registerDisabled = true
              break;
            case 2:
              vue.ordinaryVerifyBtn = time + '秒后重试'
              vue.ordinaryDisabled = true
              break;
          }
          time--;
        }
      }, 1000);
    },

    /**
     * 验证码进行比对
     * @param type 1注册
     */
    checkVerificationCode() {
      let vue = this
      let phoneNumber = ""
      let verificationCode = ""

      phoneNumber = this.register.phone
      verificationCode = this.register.verificationCode

      if (phoneNumber === "" || phoneNumber == null) {
        promptData("手机号不能为空!", this)
        return
      }
      if (verificationCode == null || verificationCode === "") {
        promptData("验证码不能为空!", this)
        return
      }
      //请求数据
      loginApi.login.checkMessageCode(phoneNumber, verificationCode, 1).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === '0') {
          vue.active = 1
          vue.verifyPhoneDiv = false
          vue.userDiv = true
        } else {
          errorPromptData(response.data.result, vue)
        }
      })
    },

    /**
     * 注册上一步
     */
    preRegister(){
      this.active = 0
      this.verifyPhoneDiv = true
      this.userDiv = false
      this.register.userName = null
      this.register.password = null
      this.register.endPassword = null
    },

    /**
     * 得到参数
     * @param name
     */
    getQuery(name){
      let after = window.location.hash.split("?")[1];
      if (after) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = after.match(reg);
        if (r != null) {
         return decodeURIComponent(r[2]);
        } else {
          return  null;
        }
      }
    },
  },

  created() {
    /*$(document).ready(function () {
      $('.form_item').click(function () {
        $('.form_item').removeClass('active')
        $(this).addClass('active')
      })
    })*/
  },
}



// WEBPACK FOOTER //
// ./src/js/Binding/Binding.js